/* ================================
   BURGER PRIME - MENU FUNCTIONALITY
   ================================ */

// Menu filtering functionality
function filterMenu(category, e) {
    const items = document.querySelectorAll('.menu-item-enhanced');
    const buttons = document.querySelectorAll('.menu-filter .filter-btn');

    // Update button states
    buttons.forEach(btn => btn.classList.remove('active'));
    if (e && e.target) {
        e.target.classList.add('active');
    } else {
        // Fallback: activate button matching the category
        buttons.forEach(btn => {
            if (btn.textContent.toLowerCase().includes(category) ||
                (category === 'all' && btn.classList.contains('filter-btn'))) {
                btn.classList.add('active');
            }
        });
    }
    
    // Filter items with animation
    items.forEach(item => {
        if (category === 'all' || item.dataset.category === category) {
            item.style.display = 'flex';
            item.classList.add('fade-in');
            setTimeout(() => {
                item.style.opacity = '1';
                item.style.transform = 'translateY(0)';
            }, 50);
        } else {
            item.style.opacity = '0';
            item.style.transform = 'translateY(20px)';
            setTimeout(() => {
                item.style.display = 'none';
            }, 300);
        }
    });
}

// Menu search functionality
function initMenuSearch() {
    const searchInput = document.getElementById('menuSearch');
    if (searchInput) {
        searchInput.addEventListener('input', function() {
            const searchTerm = this.value.toLowerCase();
            const menuItems = document.querySelectorAll('.menu-item-enhanced');
            
            menuItems.forEach(item => {
                const title = item.querySelector('.item-title')?.textContent.toLowerCase() || '';
                const description = item.querySelector('.item-desc')?.textContent.toLowerCase() || '';
                const tags = Array.from(item.querySelectorAll('.tag')).map(tag => 
                    tag.textContent.toLowerCase()
                ).join(' ');
                
                const isMatch = title.includes(searchTerm) || 
                               description.includes(searchTerm) || 
                               tags.includes(searchTerm);
                
                if (isMatch || searchTerm === '') {
                    item.style.display = 'flex';
                    item.classList.add('fade-in');
                } else {
                    item.style.display = 'none';
                }
            });
            
            // Show "no results" message if needed
            showNoResultsMessage(searchTerm);
        });
    }
}

// Show no results message
function showNoResultsMessage(searchTerm) {
    const container = document.getElementById('menuContainer');
    const visibleItems = Array.from(document.querySelectorAll('.menu-item-enhanced'))
        .filter(item => item.style.display !== 'none');
    
    // Remove existing no results message
    const existingMessage = document.getElementById('no-results-message');
    if (existingMessage) {
        existingMessage.remove();
    }
    
    // Add no results message if no items are visible and search term exists
    if (visibleItems.length === 0 && searchTerm.trim() !== '') {
        const noResultsDiv = document.createElement('div');
        noResultsDiv.id = 'no-results-message';

        const inner = document.createElement('div');
        inner.style.cssText = 'text-align: center; padding: 3rem; background: white; border-radius: 15px; box-shadow: 0 5px 15px rgba(0,0,0,0.1); margin: 2rem 0;';

        const icon = document.createElement('div');
        icon.style.cssText = 'font-size: 3rem; margin-bottom: 1rem;';
        icon.textContent = '\uD83D\uDD0D';

        const heading = document.createElement('h3');
        heading.style.cssText = 'color: var(--primary-crimson); margin-bottom: 1rem;';
        heading.textContent = 'No items found';

        const msg = document.createElement('p');
        msg.style.color = 'var(--text-light)';
        msg.textContent = `We couldn't find any menu items matching "${searchTerm}"`;

        const btn = document.createElement('button');
        btn.className = 'btn btn-primary';
        btn.style.marginTop = '1rem';
        btn.textContent = 'Clear Search';
        btn.addEventListener('click', clearSearch);

        inner.append(icon, heading, msg, btn);
        noResultsDiv.appendChild(inner);
        container.appendChild(noResultsDiv);
    }
}

// Clear search function
function clearSearch() {
    const searchInput = document.getElementById('menuSearch');
    if (searchInput) {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input'));
    }
}

// Add to cart functionality
function addToCart(itemName, price) {
    // Simple cart implementation - can be extended
    let cart = JSON.parse(localStorage.getItem('burgerPrimeCart') || '[]');
    
    const existingItem = cart.find(item => item.name === itemName);
    if (existingItem) {
        existingItem.quantity += 1;
    } else {
        cart.push({
            name: itemName,
            price: price,
            quantity: 1,
            timestamp: new Date().toISOString()
        });
    }
    
    localStorage.setItem('burgerPrimeCart', JSON.stringify(cart));
    
    // Show success message
    showCartMessage(itemName);
    updateCartCount();
}

// Show cart success message
function showCartMessage(itemName) {
    const message = document.createElement('div');
    message.style.cssText = `
        position: fixed;
        top: 100px;
        right: 30px;
        background: linear-gradient(135deg, var(--primary-crimson), var(--secondary-tangerine));
        color: white;
        padding: 1rem 1.5rem;
        border-radius: 10px;
        box-shadow: 0 5px 20px rgba(220, 20, 60, 0.4);
        z-index: 10000;
        animation: slideInRight 0.3s ease-out;
    `;
    const msgContent = document.createElement('div');
    msgContent.style.cssText = 'display: flex; align-items: center; gap: 0.5rem;';
    const checkSpan = document.createElement('span');
    checkSpan.textContent = '\u2705';
    const textSpan = document.createElement('span');
    const strong = document.createElement('strong');
    strong.textContent = itemName;
    textSpan.appendChild(strong);
    textSpan.append(' added to cart!');
    msgContent.append(checkSpan, textSpan);
    message.appendChild(msgContent);
    
    document.body.appendChild(message);
    
    setTimeout(() => {
        message.style.animation = 'slideOutRight 0.3s ease-in';
        setTimeout(() => message.remove(), 300);
    }, 3000);
}

// Update cart count in UI
function updateCartCount() {
    const cart = JSON.parse(localStorage.getItem('burgerPrimeCart') || '[]');
    const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
    
    // Update cart badge if it exists
    const cartBadge = document.querySelector('.cart-count');
    if (cartBadge) {
        cartBadge.textContent = totalItems;
        cartBadge.style.display = totalItems > 0 ? 'block' : 'none';
    }
}

// Get cart contents
function getCart() {
    return JSON.parse(localStorage.getItem('burgerPrimeCart') || '[]');
}

// Clear cart
function clearCart() {
    localStorage.removeItem('burgerPrimeCart');
    updateCartCount();
}

// Calculate cart total
function getCartTotal() {
    const cart = getCart();
    return cart.reduce((total, item) => {
        const raw = typeof item.price === 'number' ? item.price : item.price;
        const price = parseFloat(String(raw).replace(/[₹,]/g, '')) || 0;
        return total + (price * (item.quantity || 1));
    }, 0);
}

// Menu item hover effects
function initMenuHoverEffects() {
    const menuItems = document.querySelectorAll('.menu-item-enhanced');
    
    menuItems.forEach(item => {
        item.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-3px)';
            this.style.boxShadow = '0 10px 25px rgba(220, 20, 60, 0.15)';
        });
        
        item.addEventListener('mouseleave', function() {
            this.style.transform = 'translateY(0)';
            this.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
        });
    });
}

// Add click handlers to add-to-cart buttons
function initAddToCartButtons() {
    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('add-to-cart')) {
            const menuItem = e.target.closest('.menu-item-enhanced');
            const itemName = menuItem.querySelector('.item-title').textContent;
            const itemPrice = menuItem.querySelector('.price-display').textContent;
            
            addToCart(itemName, itemPrice);
        }
    });
}

// Initialize menu functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    initMenuSearch();
    initMenuHoverEffects();
    initAddToCartButtons();
    updateCartCount();
    
    console.log('🍔 Menu functionality initialized');
});

// Export functions for use in other files
window.MenuModule = {
    filterMenu,
    addToCart,
    getCart,
    clearCart,
    getCartTotal,
    updateCartCount
};